// The point of making this global store is to collect all the stores here collectively and import them directly from here whenever required
import { useApplianceStore } from '../product/ams/modules/appliance/store';
import { useAuthStore } from '../modules/auth/store';
import { useAttributeStore } from '../product/pha/modules/attribute/store';
import { useCategoryStore } from '../product/pha/modules/category/store';
import { useCompanyStore } from '../modules/company/store';
import { useCommentStore } from '../product/ams/modules/comment/store';
import { useDebriefStore } from '../product/ams/modules/debrief/store';
import { useDepartmentStore } from '../product/ams/modules/department/store';
import { useFormulaStore } from '../product/pha/modules/formula/store';
import { useGroupStore } from '../modules/group/store';
import { useIncidentStore } from '../product/ams/modules/incident/store';
import { useLearningOutcomeStore } from '../product/ams/modules/learning-outcome/store';
import { useLicenseStore } from '../modules/license/store';
import { usePermissionStore } from '../modules/permission/store';
import { useProductStore } from '../modules/product/store';
import { usePropertyTypeStore } from '../product/ams/modules/property-type/store';
import { useReportStore } from '../product/ams/modules/report/store';
import { useSourceStore } from '../product/ams/modules/source/store';
import { useTaskStore } from '../product/ams/modules/task/store';
import { usethemeStore } from '../product/ams/modules/theme/store';
import { usefileStore } from '../modules/file/store';
import { useUserStore } from '../modules/user/store';

import { useFormErrorStore } from './form-errors';
import { useChecklistStore } from '@/product/ams/modules/checklist/store';
import { useStationStore } from '@/product/ams/modules/station/store';
import { useSSOStore } from '@/modules/sso/store';
import { useLabelRenameStore } from '../modules/label-rename/store';
const applianceStore = useApplianceStore();
const authStore = useAuthStore();
const attributeStore = useAttributeStore();
const categoryStore = useCategoryStore();
const companyStore = useCompanyStore();
const commentStore = useCommentStore();
const debriefStore = useDebriefStore();
const departmentStore = useDepartmentStore();
const formulaStore = useFormulaStore();
const groupStore = useGroupStore();
const incidentStore = useIncidentStore();
const learningOutcomeStore = useLearningOutcomeStore();
const licenseStore = useLicenseStore();
const permissionStore = usePermissionStore();
const productStore = useProductStore();
const propertyTypeStore = usePropertyTypeStore();
const reportStore = useReportStore();
const sourceStore = useSourceStore();
const taskStore = useTaskStore();
const themeStore = usethemeStore();
const fileStore = usefileStore();
const userStore = useUserStore();
const formErrorStore = useFormErrorStore();
const checkListStore = useChecklistStore()
const stationStore = useStationStore();
const ssoAuth = useSSOStore();
const labelRenameStore = useLabelRenameStore();
export {
    applianceStore,
    authStore,
    attributeStore,
    categoryStore,
    companyStore,
    commentStore,
    debriefStore,
    departmentStore,
    formulaStore,
    groupStore,
    incidentStore,
    learningOutcomeStore,
    licenseStore,
    permissionStore,
    productStore,
    propertyTypeStore,
    reportStore,
    sourceStore,
    taskStore,
    themeStore,
    fileStore,
    userStore,
    formErrorStore,
    checkListStore,
    stationStore,
    ssoAuth,
    labelRenameStore
};
